import { createEffect, createStore } from 'effector';
import { request } from 'src/common/request';
import { Interest, InterestsBlock } from 'src/domain/interest';

export const fetchInterestsFx = createEffect<void, Interest[]>({
	handler: async () => {
		const { data } = await request.get('/interests');

		return data;
	},
});
export const fetchInterestsBlocksFx = createEffect<void, InterestsBlock[]>({
	handler: async () => {
		const { data } = await request.get('/interests/blocks');

		return data;
	},
});

export const interests$ = createStore<Interest[]>([])
	.on(fetchInterestsFx.doneData, (_, interests) => interests);
export const interestsBlocks$ = createStore<InterestsBlock[]>([])
	.on(fetchInterestsBlocksFx.doneData, (_, blocks) => blocks);
